import React from 'react';
import { createBranch, updateResponse, getClubs } from "../../api/branchapi";
import { getTimeZones } from "../../api/timeZoneApi";
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";
import { Form, Input, Label, Button, Row, Col } from 'reactstrap';
import CustomDatePicker from '../CustomDatePicker';
import PopupError from '../PopupError';
import FormValidator from '../FormValidation';
import RequiredFieldNotation from '../utils/RequiredFieldNotation';
import feedback from '../utils/feedback';
import InputFeedback from '../utils/InputFeedback';
import '../css/EditCreate.css';
class ClubCreate extends React.Component {

    constructor(props) {
        super(props);
        this.props.route.history.push('/secure/branches');
        this.props.route.history.push(this.props.route.match.url);
        this.validator = new FormValidator([
            {
                field: 'name',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'branchCode',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'branchCode',
                method: 'isNumeric',
                //args: [{ min: 21, max: 65 }],
                validWhen: true,
                message: 'Value must be a number.'
            },
            {
                field: 'startDate',
                method: this.isBefore,
                validWhen: true,
                message: 'Start date must be before end date.'
            },
            {
                field: 'clubName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'timeZone',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'customerServiceEmail',
                method: (fieldValue) => {
                    if (fieldValue.trim() === '') {
                        return false
                    }

                    return this.isEmail(fieldValue);
                },
                validWhen: false,
                message: 'Please enter valid emails.'
            },
            {
                field: 'branchTerms',
                method: (fieldValue) => (fieldValue || '').length <= 255,
                validWhen: true,
                message: 'The maximum length is 255 characters.'
            }
        ])
        this.state = {
            branch: {
                name: '',
                branchCode: '',
                startDate: '',
                clubId: '',
                endDate: '',
                clubName: '',
                systemTimeZoneName: '',
                systemTimeZoneId: '',
                customerServiceEmail: '',
                saleTaxRate: 0,
                branchTerms: '',
            },
            timeZones: [],
            clubs: [],
            cancel: false,
            saved: false,
            error: false,
            errorMessage: [],
            branchId: '',
            validation: this.validator.valid()
        }
        this.handleCancel = this.handleCancel.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    isBefore = (confirmation, state) => (state.endDate >= confirmation || !state.endDate);
    isAfter = (confirmation, state) => (state.startDate <= confirmation);
    isEmail = (state) => {
        return (!state.match(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25}(;[ ]{0,1}([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})*$/));
    }

    componentDidUpdate(prevProps) {
        //Checks if there is a response on update
        if (this.props.updateResult !== prevProps.updateResult) {
            var result = this.props.updateResult
            //Checks if the response is success or has errors.
            if (result) {
                if (result.data.success) {
                    this.setState(state => ({
                        saved: true,
                        branchId: result.data.data.branchId
                    }));
                    console.log(result.data.data.branchId, "data");
                    //This is backend validation error handling
                } else if (result.data.success == false) {
                    var errorList = [];
                    result.data.errors.map(function (e) { errorList.push(e.message) })
                    this.setState({ error: true, errorMessage: errorList })
                }
                //This is database error handling
                else {
                    let message = Object.keys(result.data.errors).map((function (e) { return 'there was an error saving ' + e }));
                    this.setState({ error: true, errorMessage: message });
                }
                this.props.updateResponse("");
            }
        }
    }

    componentDidMount() {
        this.props.getClubs(function (result, _this) { _this.getData(result, _this) }, this);
        this.props.getTimeZones(function (result, _this) { _this.getDataTimeZones(result, _this) }, this);
        this.setState({
            loading: true
        })
    }

    changeSaleTaxRate = e => {
        let val = e.target.value;
        val = val.replace(/([^0-9.]+)/, "");
        val = val.replace(/^(0|\.)/, "");
        const match = /(\d{0,7})[^.]*((?:\.\d{0,4})?)/g.exec(val);
        const value = match[1] + match[2];
        e.target.value = value;
        this.state.branch.saleTaxRate = value;
        if (val.length > 0) {
            e.target.value = Number(value).toFixed(4);
            this.state.branch.saleTaxRate = Number(value).toFixed(4);
        }
    }

    renderTimeZones() {
        let timeZones = this.state.timeZones;

        return timeZones.map((timeZone, index) => {
            return (
                <option id={timeZone.systemTimeZoneId} key={index}>{timeZone.name}</option>
            );
        });
    }

    renderClubNames() {
        let clubs = this.state.clubs;

        return clubs.map((club, index) => {
            return (
                <option id={club.clubId} key={index}>{club.name}</option>
            );
        });
    }

    getData(data, _this) {
        //sets the branch.clubName and branch.clubId to first array of clubs

        let clubs = data.data.data;
        if (clubs.length != 1) {
            clubs.unshift("");
        } else {
            var x = this.state.branch; x.clubName = data.data.data[0].name; // <-- The first option will never save without a change to the input.
            var y = this.state.branch; y.clubId = data.data.data[0].clubId
            _this.setState({
                branch: x,
                branch: y
            })
        }

        _this.setState({
            clubs: clubs,
        })
    }

    getDataTimeZones(data, _this) {

        let timeZones = data.data.data;
        if (timeZones.length != 1) {
            timeZones.unshift("");
        } else {
            var x = this.state.branch;
            x.systemTimeZoneName = data.data.data[0].name;
            var y = this.state.branch;
            y.systemTimeZoneId = data.data.data[0].systemTimeZoneId
            _this.setState({
                branch: x,
                branch: y
            })
        }

        _this.setState({
            timeZones: timeZones,
        })
    }

    handleFormSubmit = event => {
        event.preventDefault();

        var updVal = this.state.branch;
        updVal.startDate = document.getElementById("startDate").value;
        updVal.endDate = document.getElementById("endDate").value;
        updVal.branchTerms = (this.state.branch.branchTerms || '').trim() || null;
        this.setState({ branch: updVal }, () => {
            const validation = this.validator.validate(this.state.branch);
            this.setState({ validation });
            this.submitted = true;
            if (validation.isValid) {
                // handle actual form submission here
                this.props.createBranch(updVal);
            }
        });
    }

    //Redirects to club list
    handleCancel = () => {
        this.setState({
            cancel: true
        })
    }

    isInvalid(e) {
        var input = e.target;
        if (input.value) { input.classList.remove("is-invalid"); }
        else { input.classList.add("is-invalid"); }
    }

    //Closes the popup when the X is clicked or click outside the modal.
    closeModal() {
        this.setState({ error: false });
    }

    render() {
        const branch = this.state.branch;
        //Redirects to branch list when cancel button is triggered
        if (this.state.cancel) {
            return <Redirect
                to={{
                    pathname: `/secure/branches`,
                }}
            />;
        }
        //Redirects to branch list when save is succesful
        if (this.state.saved) {
            return <Redirect
                to={{
                    pathname: `/secure/branchEdit/${this.state.branchId}`,
                    state: { branchId: this.state.branchId }
                }}
            />;
        }

        let validation = this.submitted ?                         // if the form has been submitted at least once
            this.validator.validate(this.state.branch) :   // then check validity every time we render
            this.state.validation                   // otherwise just use what's in state
        if (document.querySelector('.nativeDatePicker')) document.querySelector('.nativeDatePicker').style.display = 'none';

        return (
            <div className="card">

                <PopupError
                    open={this.state.error}
                    onClose={this.closeModal}
                    onClick={this.closeModal}
                    errorMessage={this.state.errorMessage} />

                <div className="card-header text-center"> Add Branch</div>
                <div className="card-body fs-12">
                    <Form onSubmit={this.handleSubmit}>
                        <RequiredFieldNotation />
                        <div className="row">
                            <div className="col-md-6">
                                <Col className={`${validation.name.isInvalid ? 'has-error' : ''}`}>
                                    <Label htmlFor='name' className="required-hint mt-4"><strong>Branch</strong></Label>
                                    <Input
                                        id="name"
                                        type="input"
                                        name="name"
                                        maxLength="150"
                                        className="input-editable"
                                        autoComplete="off"
                                        value={branch.name}
                                        onChange={(e) => { this.isInvalid(e); var x = branch; x.name = e.target.value; this.setState({ branch: x }) }} />
                                    <span className="help-block">{validation.name.message}</span>
                                </Col>
                                <Col className={`${validation.branchCode.isInvalid ? 'has-error' : ''}`}>
                                    <Label htmlFor='branchCode' className="required-hint mt-4"><strong>Branch code</strong></Label>
                                    <Input
                                        type="number"
                                        name="branchCode"
                                        id='branchCode'
                                        className="input-editable"
                                        value={branch.branchCode}
                                        onChange={(e) => {
                                            this.isInvalid(e);
                                            var x = branch; x.branchCode = e.target.value; this.setState({ branch: x })
                                        }} />
                                    <InputFeedback feedbackText={feedback.numericValue} id='branchCode' />
                                    <span className="help-block">{validation.branchCode.message}</span>
                                </Col>
                                <Row>
                                    <div className="col-md-12">
                                        <Col >
                                            <Label htmlFor='saleTaxRate' className="mt-4"><strong>Sale Tax Rate</strong><span> (enter values ​​greater than 0 up to 1, for example, 6% as 0.06, 5.5% as 0.055.)</span></Label>
                                            <Input
                                                type="number"
                                                maxLength="20"
                                                name="saleTaxRate"
                                                id='saleTaxRate'
                                                className="input-editable"
                                                value={branch.saleTaxRate}
                                                onBlur={(e) => { this.changeSalesTax(e) }}
                                                onChange={(e) => { this.isInvalid(e); var x = branch; x.saleTaxRate = e.target.value; this.setState({ branch: x }) }} />
                                        </Col>
                                    </div>
                                </Row>
                                <Row>
                                    <div className="col-md-6">
                                        <Col className={`${validation.startDate.isInvalid ? 'has-error' : ''}`}>
                                            <Label htmlFor='startDate' className="mt-4"><strong>Start date</strong></Label>
                                            <CustomDatePicker
                                                id="startDate"
                                                readOnly={false}
                                                defValue={branch.startDate.substring(0, 10)}
                                                label="Start Date"
                                            />
                                            <InputFeedback feedbackText={feedback.startDate} id='startDate' />
                                            <span className="help-block-calendar">{validation.startDate.message}</span>
                                        </Col>
                                    </div>
                                    <div className="col-md-6">
                                        <Col>
                                            <Label htmlFor='endDate' className="mt-4"><strong>End date</strong></Label>
                                            <CustomDatePicker
                                                id="endDate"
                                                readOnly={false}
                                                defValue={branch.endDate.substring(0, 10)}
                                                label="End Date"
                                            />
                                        </Col>
                                    </div>
                                </Row>
                            </div>

                            <div className="col-md-6">
                                <Col className={`${validation.clubName.isInvalid ? 'has-error' : ''}`}>
                                    <Label htmlFor='clubName' className=" required-hint mt-4"><strong>Club</strong></Label>
                                    <label className="select">
                                        <select
                                            id="clubName"
                                            name="clubName"
                                            className="form-control input-editable"
                                            value={branch.clubName}
                                            onChange={(e) => {
                                                var x = this.state.branch; x.clubName = e.target.value;
                                                var y = this.state.branch; y.clubId = e.target[e.target.selectedIndex].getAttribute('id');
                                                this.setState({ branch: y, branch: x })
                                            }}
                                        >
                                            {this.renderClubNames()}
                                        </select>
                                    </label>
                                    <span className="help-block">{validation.clubName.message}</span>
                                </Col>
                                <Col className={`${validation.customerServiceEmail.isInvalid ? 'has-error' : ''}`}>
                                    <Label htmlFor='email' className="mt-4"><strong>Customer Service Email</strong></Label>
                                    <Input
                                        readOnly={this.state.readOnly}
                                        type="text"
                                        maxLength="256"
                                        name="customerServiceEmail"
                                        id='email'
                                        autoComplete="off"
                                        className={this.state.readOnly ? '' : 'input-editable form-control'}
                                        value={branch.customerServiceEmail}
                                        onChange={(e) => { this.isInvalid(e); var x = branch; x.customerServiceEmail = e.target.value; this.setState({ branch: x }) }} />
                                    <InputFeedback feedbackText={feedback.email} id='email' />
                                    <span className="help-block">{validation.customerServiceEmail.message}</span>
                                </Col>
                                <Col className={`${validation.timeZone.isInvalid ? 'has-error' : ''}`}>
                                    <Label htmlFor='timeZone' className=" required-hint mt-4"><strong>Local time zone</strong></Label>
                                    <label className="select">
                                        <select
                                            id="timeZone"
                                            name="timeZone"
                                            className="form-control input-editable"
                                            value={branch.systemTimeZoneName}
                                            onChange={(e) => {
                                                var x = this.state.branch;
                                                x.systemTimeZoneName = e.target.value;
                                                var y = this.state.branch;
                                                y.systemTimeZoneId = e.target[e.target.selectedIndex].getAttribute('id');
                                                this.setState({ branch: y, branch: x })
                                            }}
                                        >
                                            {this.renderTimeZones()}
                                        </select>
                                    </label>
                                    <span className="help-block">{validation.timeZone.message}</span>
                                    <Label htmlFor='branchTerms' className="mt-4"><strong>Branch Terms &amp; Conditions</strong></Label>
                                    <Input
                                        id="branchTerms"
                                        style={{ height: 52 }}        
                                        type="textarea"
                                        className="input-editable-product"    
                                        maxLength="255"
                                        value={branch.branchTerms || ''}
                                        onChange={(e) => {
                                            this.isInvalid(e);
                                            var x = branch; x.branchTerms = e.target.value;
                                            this.setState({ branch: x });
                                        }}
                                        placeholder="Enter terms and conditions (max 255)"
                                    />
                                    <div className="text-right text-muted" style={{ fontSize: 12 }}>
                                        {(branch.branchTerms || '').length}/255
                                    </div>
                                    <div className="text-right float-bottom">
                                        <Button onClick={this.handleCancel.bind(this)} className="cancel-btn">CANCEL</Button>
                                        <Button type="submit" onClick={e => this.handleFormSubmit(e)} className="save-btn">SAVE</Button>
                                    </div>
                                </Col>
                            </div>
                        </div>
                    </Form>
                </div>
            </div >
        );
    }
}
export default connect(
    state => {
        return {
            updateResult: state.data.updateResult,
            clubs: state.data.clubs,
            timeZones: state.data.timeZones
        }
    },
    dispatch => ({
        createBranch: (branch) => { dispatch(createBranch(branch)) },
        updateResponse: (response) => { dispatch(updateResponse(response)) },
        getClubs: (callback, context) => { dispatch(getClubs(callback, context)) },
        getTimeZones: (callback, context) => { dispatch(getTimeZones(callback, context)) }
    }
    )
)(ClubCreate);